"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTokenRefresh = instanceOfTokenRefresh;
exports.TokenRefreshFromJSON = TokenRefreshFromJSON;
exports.TokenRefreshFromJSONTyped = TokenRefreshFromJSONTyped;
exports.TokenRefreshToJSON = TokenRefreshToJSON;
exports.TokenRefreshToJSONTyped = TokenRefreshToJSONTyped;
/**
 * Check if a given object implements the TokenRefresh interface.
 */
function instanceOfTokenRefresh(value) {
    if (!('access' in value) || value['access'] === undefined)
        return false;
    return true;
}
function TokenRefreshFromJSON(json) {
    return TokenRefreshFromJSONTyped(json, false);
}
function TokenRefreshFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'access': json['access'],
    };
}
function TokenRefreshToJSON(json) {
    return TokenRefreshToJSONTyped(json, false);
}
function TokenRefreshToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {};
}
//# sourceMappingURL=tokenRefresh.js.map